import { useMemo } from 'react';

export type GateGroupBalance = {
  balance?: any;
};

export type BaseGateGroup = {
  cascade_id?: string | null;
  provider_family?: string | null;
  active_gate: {
    currency_id?: string | null;
  }[];
  gate_group_balance?: GateGroupBalance | null;
};

export type TransformedGateGroup<Group extends BaseGateGroup> = Group & {
  currency_id?: string;
  gate_group_balance?: GateGroupBalance | null;
  subGroups?: Group[];
};

export const CASCADE_PROVIDER_FAMILY = 'cascade';

export function useTransformedGateGroups<Group extends BaseGateGroup>(groups?: Group[]): TransformedGateGroup<Group>[] {
  return useMemo(() => {
    let result: Group[] = [];

    groups?.forEach((group) => {
      const currencyId = group.active_gate.at(0)?.currency_id ?? undefined;

      if (!group.cascade_id) {
        result.push({
          ...group,
          currency_id: currencyId,
        });

        return;
      }

      if (group.provider_family !== CASCADE_PROVIDER_FAMILY) {
        return;
      }

      const subGroups = groups.filter(
        ({ cascade_id, provider_family }) =>
          cascade_id === group.cascade_id && provider_family !== CASCADE_PROVIDER_FAMILY
      );

      result.push({
        ...group,
        currency_id: currencyId,
        subGroups,
        active_gate: subGroups.flatMap((subGroup) => subGroup.active_gate),
        gate_group_balance: {
          balance: subGroups.reduce((acc, subGroup) => acc + (subGroup.gate_group_balance?.balance ?? 0), 0),
        },
      });
    });

    result = result.filter((group) => group.active_gate.length > 0);

    return result;
  }, [groups]);
}
